import { z } from 'zod';
import { SUPPORTED_LOCALES } from './locales.js';
export const localeSchema = z.enum(SUPPORTED_LOCALES);
